import React from "react";

// project-imports
import TestimonialForm from "./TestimonialForm";

const TestimonialModal = ({ toggleModal }) => {

  return (
    <div className={"edu-search-popup open"}>
      <div className="close-button custom_close-btn">
        <button className="close-trigger" onClick={toggleModal}>
          <i className="ri-close-line"></i>
        </button>
      </div>
      <div className="inner bg-white">
        <div className="eduvibe-contact-us edu-contact-us-area edu-section-gap">
          <TestimonialForm formStyle="rnt-contact-form rwt-dynamic-form row" />
        </div>
      </div>
    </div>
  );
};

export default TestimonialModal;
